module.exports = __webpack_public_path__ + "assets/jipiao.6047c769.svg";